'use strict';

module.exports = require('./Progress');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-progress/lib/index.js
 ** module id = 433
 ** module chunks = 0
 **/